import type { House, HouseListItem, Tag } from "@/houses/types";
import { apiClient } from "./apiClient";

export const housesGateway = {
  async getHouses(): Promise<Array<HouseListItem>> {
    return await apiClient.get(`/api/houses`);
  },

  async getHouse(houseId: number): Promise<House> {
    return await apiClient.get(`/api/houses/${houseId}`);
  },

  async updateHouse(house: House): Promise<House> {
    return await apiClient.put(`/api/houses/${house.id}`, house);
  },

  async patchHouseHidden(houseId: number, hidden: boolean): Promise<House> {
    return await apiClient.patch(`/api/houses/${houseId}/hidden`, { hidden });
  },

  async getAllTags(): Promise<Array<Tag>> {
    return await apiClient.get(`/api/houses/tags`);
  },
};
